import React from 'react';
import logo from "../../assets/img/logo.svg";

function ContractItem({ timesheet, isSelected, onClick }) {
    return (
        <div
            className={`timesheet-item ${isSelected ? 'selected' : ''} ${timesheet.status === 'À SIGNER' ? '' : 'archived'}`}
            onClick={onClick}
        >
            <div>
                <p >CONTRAT N°{timesheet.number}</p>
                <h3>{timesheet.date}</h3>
                <p>{timesheet.role}</p>
            </div>
            <div>
                <div className={`status ${timesheet.status === 'À SIGNER' ? 'todo' : 'archived'}`}>
                    {timesheet.status}
                </div>
            </div>
        </div>
    );
}

export default ContractItem;
